import { rootApi } from '../rootApi';
import {
  ChatRequest,
  ChatResponse,
  MatchResponse,
  NudgesResponse,
  OrgPromptRequest,
  OrgPromptResponse,
  OutreachRequest,
  OutreachResponse,
} from './ai.types';

export const aiApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiMatch: builder.query<MatchResponse, { jobId: string; limit?: number }>({
      query: ({ jobId, limit = 10 }) => ({
        url: '/ai/match',
        params: { jobId, limit },
      }),
      keepUnusedDataFor: 3600,
    }),

    postAiChat: builder.mutation<ChatResponse, ChatRequest>({
      query: (body) => ({
        url: '/ai/chat',
        method: 'POST',
        data: body,
      }),
    }),

    getAiNudges: builder.query<NudgesResponse, void>({
      query: () => ({ url: '/ai/nudges' }),
    }),

    postAiOutreach: builder.mutation<OutreachResponse, OutreachRequest>({
      query: (body) => ({
        url: '/ai/outreach',
        method: 'POST',
        data: body,
      }),
    }),

    getOrgPrompt: builder.query<OrgPromptResponse, void>({
      query: () => ({ url: '/ai/org-prompt' }),
      providesTags: ['OrgPrompt'],
    }),

    putOrgPrompt: builder.mutation<{ success: boolean }, OrgPromptRequest>({
      query: (body) => ({
        url: '/ai/org-prompt',
        method: 'PUT',
        data: body,
      }),
      invalidatesTags: ['OrgPrompt'],
    }),
  }),
});

export const {
  useGetAiMatchQuery,
  usePostAiChatMutation,
  useGetAiNudgesQuery,
  usePostAiOutreachMutation,
  useGetOrgPromptQuery,
  usePutOrgPromptMutation,
} = aiApi;
